import { render, staticRenderFns } from "./kryptAlert.vue?vue&type=template&id=b466dd94&scoped=true&v-bind%3Aclass=color&v-html=displayedText&"
import script from "./kryptAlert.vue?vue&type=script&lang=js&"
export * from "./kryptAlert.vue?vue&type=script&lang=js&"
import style0 from "./kryptAlert.vue?vue&type=style&index=0&id=b466dd94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b466dd94",
  null
  
)

export default component.exports